import * as React from 'react';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide
} from '@material-ui/core';
import {
    createStyles,
    WithStyles,
    withStyles
} from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { TransitionProps } from '@material-ui/core/transitions';

export enum DialogResult {
    Unknown = 0,
    Ok,
    Cancel
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const styles = (theme: Theme) => createStyles({
    cancelButton: {
        color: theme.ccPalette.cancel.main
    },
    promptText: {
        wordBreak: 'break-all',
        whiteSpace: 'pre-line',
    }
});

interface Props extends WithStyles<typeof styles> {
    buttonOkLabel: string;
    buttonCancelLabel: string;
    className: string;
    contentText: string;
    open: boolean;
    titleText: string;
    onDialogResult: (result: DialogResult) => void;
    fullscreen?: boolean;
    testId?: string;
}

class SimpleDialog extends React.Component<Props> {
    public static defaultProps: Partial<Props> = {
        buttonOkLabel: 'Ok',
        buttonCancelLabel: 'Cancel',
        className: ''
    };

    invokeModalResult = (dialogResult: DialogResult) => {
        const { onDialogResult } = this.props;
        if(onDialogResult) {
            onDialogResult(dialogResult);
        }
    }

    onHandleClose = () => {
        this.invokeModalResult(DialogResult.Unknown);
    };

    onOkButtonClicked = () => {
        this.invokeModalResult(DialogResult.Ok);
    };

    onCancelButtonClicked = () => {
        this.invokeModalResult(DialogResult.Cancel);
    };

    public render() {
        const {
            classes,
            open,
            buttonOkLabel,
            buttonCancelLabel,
            contentText,
            titleText,
            fullscreen,
            testId
        } = this.props;

        // Fixes a bug in Material UI  library that keeps the popup's overlay
        // absorbing the mouse events once closed.
        if (!open) {
            return '';
        }

        return (
            <Dialog
                open={open}
                keepMounted={false}
                onClose={this.onHandleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                TransitionComponent={Transition}
                fullScreen={fullscreen}
                data-testid={testId ? testId : 'simple-modal'}
            >
                <DialogTitle id="alert-dialog-slide-title">
                    {titleText}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" className={classes.promptText}>
                        {contentText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {
                        (buttonCancelLabel && buttonCancelLabel.length > 0) ?
                            <Button
                                className={classes.cancelButton}
                                onClick={this.onCancelButtonClicked}
                                data-testid="cancel-dialog-button"
                            >
                                {buttonCancelLabel}
                            </Button>
                            : ''
                    }
                    {
                        (buttonOkLabel && buttonOkLabel.length > 0) ?
                            <Button
                                onClick={this.onOkButtonClicked}
                                color="primary"
                                data-testid="ok-dialog-button"
                            >
                                {buttonOkLabel}
                            </Button>
                            : ''
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

const MUIComponent = withStyles(styles)(SimpleDialog);
export {MUIComponent as SimpleDialog};
